.ux-iws-link-wrapper {
    display: block;

    &--with-link {
        cursor: pointer;
    }

    &:hover {
        /* stylelint-disable max-nesting-depth */
        .ux-button:not(.ux-button--primary):not(.ux-button--green):not(.ux-button--red) {
            background: $color-black;
            color: $color-white;

            ux-icon {
                color: $color-white;
            }
        }

        .ux-button--primary,
        .ux-button--green {
            background: $color-white;
            color: $color-green;

            ux-icon {
                color: $color-green;
            }
        }
        /* stylelint-enable max-nesting-depth */
    }
}
